import AriaSelectDropdown from '@/common/AriaSelectDropdown';
import ControlledInput from '@/common/ControllerInput';
import { CustomAddress } from '@/explore/types';

interface CustomAddressesEditProps {
  addCustomAddress: Array<CustomAddress>;
  customeAddress: Array<CustomAddress>;
  shippingAddressOptions: Object;
  shippingAddressSelecValue: string;
  onClickAddCustomAddress(): void;
  onClickRemoveCustomAddress(contactDetailId: number): void;
  onChangeCustomAddressField(
    value: string | number | boolean,
    fieldName: string,
    customAddressIndex: number,
    isNew?: boolean
  ): void;
  onClickRemoveCustomAddressNewField(customAddressIndex: number): void;
  onChangeDefaultShippingAddress(arg: string): void;
}

function CustomAddresses({
  addCustomAddress,
  customeAddress,
  onClickAddCustomAddress,
  onClickRemoveCustomAddress,
  onChangeCustomAddressField,
  onClickRemoveCustomAddressNewField,
  shippingAddressOptions,
  onChangeDefaultShippingAddress,
  shippingAddressSelecValue
}: CustomAddressesEditProps) {
  const onChangeCustomAddress = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number,
    fieldName: string
  ) => onChangeCustomAddressField(event.target.value, fieldName, index, true);
  // const onClickSetPrimary = (customAddressIndex: number, isNew: boolean) => {
  //   addCustomAddress.map((_, index) =>
  //     onChangeCustomAddressField(false, 'is_primary', index, true)
  //   );
  //   customeAddress.map((_, index) =>
  //     onChangeCustomAddressField(false, 'is_primary', index, false)
  //   );
  //   onChangeCustomAddressField(true, 'is_primary', customAddressIndex, isNew);
  // };

  const getFloatingLabel = (labels: Array<string>) => {
    return labels.map((label) => (label.includes('CUSTOM') ? 'PHYSICAL' : label));
  };

  return (
    <div className="contact-details-edit">
      <div className="shipping-address-edit">
        <div className="shipping-address-edit__label">
        Preferred Shipping Address
        </div>
        <div className="shipping-address-edit__select">
          <AriaSelectDropdown
            options={Object.entries(shippingAddressOptions)}
            className="react-aria-Select react-aria-select-light"
            commonClassNamePrefix="shipping-address-edit__select"
            variant="light"
            placeholder="-Select default shipping address-"
            floatingLabel={getFloatingLabel(
              Object.keys(shippingAddressOptions)
            )}
            onChangeDropdown={onChangeDefaultShippingAddress}
            selectedOption={shippingAddressSelecValue}
          />
        </div>
      </div>
      <div className="contact-detail-list">
        {customeAddress.map((customAddress, index) => (
          <div className="custom-address-item" key={index}>
              <div className="contact-detail-item__primary-header">
                Physical Address
              </div>
            <div className="contact-detail-form">
              <div className="contact-detail-form__item">
                <div className="contact-detail-form__item-row">
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter Street"
                    value={customAddress.street}
                    onChange={(event) =>
                      onChangeCustomAddressField(
                        event.target.value,
                        'street',
                        index
                      )
                    }
                  />
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter City"
                    value={customAddress.city}
                    onChange={(event) =>
                      onChangeCustomAddressField(
                        event.target.value,
                        'city',
                        index
                      )
                    }
                  />
                  {/* <CustomRadio
                    name={'is_primary'}
                    id={`add-address-${index}`}
                    value="is_primary"
                    isChecked={customAddress.is_primary as boolean}
                  />
                  <label
                    className="license-edit__checkbox-label active-label"
                    htmlFor={`add-phone-label-${index}`}
                  >
                    Primary
                  </label> */}
                </div>
                {((customAddress.errors && customAddress?.errors.street) ||
                  (customAddress.errors && customAddress?.errors.city)) && (
                  <div className="custom-address-form__input-error">
                    <div className="edit-error">
                      {customAddress.errors && customAddress?.errors.street && (
                        <>* {customAddress?.errors.street}</>
                      )}
                    </div>
                    <div className="edit-error">
                      {customAddress.errors && customAddress?.errors.city && (
                        <>* {customAddress?.errors.city}</>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="contact-detail-form__item">
                <div className="contact-detail-form__item-row">
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter State"
                    value={customAddress.state}
                    onChange={(event) =>
                      onChangeCustomAddressField(
                        event.target.value,
                        'state',
                        index
                      )
                    }
                  />
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="number"
                    placeholder="Enter Zip Code"
                    value={customAddress.zipcode}
                    onChange={(event) =>
                      onChangeCustomAddressField(
                        event.target.value,
                        'zipcode',
                        index
                      )
                    }
                  />
                </div>
                {((customAddress.errors && customAddress?.errors.state) ||
                  (customAddress.errors && customAddress?.errors.zipcode)) && (
                  <div className="custom-address-form__input-error">
                    <div className="edit-error">
                      {customAddress.errors && customAddress?.errors.state && (
                        <>* {customAddress?.errors.state}</>
                      )}
                    </div>
                    <div className="edit-error">
                      {customAddress.errors &&
                        customAddress?.errors.zipcode && (
                          <>* {customAddress?.errors.zipcode}</>
                        )}
                    </div>
                  </div>
                )}
              </div>
              <button
                className="business-custom-address-underline-btn"
                onClick={() =>
                  onClickRemoveCustomAddress(customAddress.id as number)
                }
              >
                Remove
              </button>
              {/* {!customAddress.is_primary && (
                <>
                  <span className="business-btn-seprator">|</span>
                  <button
                    className="business-custom-address-underline-btn"
                    onClick={() => onClickSetPrimary(index, false)}
                  >
                    Set As Primary
                  </button>
                </>
              )} */}
            </div>
          </div>
        ))}
        {addCustomAddress.map((customAddress, index) => (
          <div className="contact-detail-item" key={index}>
            <div className="contact-detail-item__primary-header">
              Physical Address
            </div>
            <div className="contact-detail-form">
              <div className="contact-detail-form__item">
                <div className="contact-detail-form__item-row">
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter Street"
                    value={customAddress.street}
                    onChange={(event) =>
                      onChangeCustomAddress(event, index, 'street')
                    }
                  />
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter City"
                    value={customAddress.city}
                    onChange={(event) =>
                      onChangeCustomAddress(event, index, 'city')
                    }
                  />
                  {/* <CustomRadio
                    name={'is_primary'}
                    id={`add-address-${index}`}
                    value="is_primary"
                    isChecked={customAddress.is_primary as boolean}
                  />
                  <label
                    className="license-edit__checkbox-label active-label"
                    htmlFor={`add-phone-label-${index}`}
                  >
                    Primary
                  </label> */}
                </div>
                {((customAddress.errors && customAddress?.errors.street) ||
                  (customAddress.errors && customAddress?.errors.city)) && (
                  <div className="custom-address-form__input-error">
                    <div className="edit-error">
                      {customAddress.errors && customAddress?.errors.street && (
                        <>* {customAddress?.errors.street}</>
                      )}
                    </div>
                    <div className="edit-error">
                      {customAddress.errors && customAddress?.errors.city && (
                        <>* {customAddress?.errors.city}</>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className="contact-detail-form__item">
                <div className="contact-detail-form__item-row">
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter State"
                    value={customAddress.state}
                    onChange={(event) =>
                      onChangeCustomAddress(event, index, 'state')
                    }
                  />
                  <ControlledInput
                    className="license-edit__input contact-detail-form__contact-name"
                    type="text"
                    placeholder="Enter Zip Code"
                    value={customAddress.zipcode}
                    onChange={(event) =>
                      onChangeCustomAddress(event, index, 'zipcode')
                    }
                  />
                </div>
                {((customAddress.errors && customAddress?.errors.state) ||
                  (customAddress.errors && customAddress?.errors.zipcode)) && (
                  <div className="custom-address-form__input-error">
                    <div className="edit-error">
                      {customAddress.errors && customAddress?.errors.state && (
                        <>* {customAddress?.errors.state}</>
                      )}
                    </div>
                    <div className="edit-error">
                      {customAddress.errors &&
                        customAddress?.errors.zipcode && (
                          <>* {customAddress?.errors.zipcode}</>
                        )}
                    </div>
                  </div>
                )}
              </div>
              <button
                className="business-custom-address-underline-btn"
                onClick={() => onClickRemoveCustomAddressNewField(index)}
              >
                Remove
              </button>
              {/* {!customAddress.is_primary && (
                <>
                  <span className="business-btn-seprator">|</span>
                  <button
                    className="business-custom-address-underline-btn"
                    onClick={() => onClickSetPrimary(index, true)}
                  >
                    Set As Primary
                  </button>
                </>
              )} */}
            </div>
          </div>
        ))}
      </div>
      <button
        className="business-add-btn"
        onClick={onClickAddCustomAddress}
        disabled={addCustomAddress.length + customeAddress.length >= 3}
      >
        + Add Address
      </button>
    </div>
  );
}

export default CustomAddresses;
